<panel width="800">
  @if (logEntries) {
    <list-view [selectable]="false" scrollable>
      <header defaultSort="descending">{{ 'search-log.time-stamp' | translate }}</header>
      <header>{{ 'search-log.event' | translate }}</header>
      <header>{{ 'search-log.id' | translate }}</header>
      <header>{{ 'search-log.user' | translate }}</header>
      <ng-container *listData="let entry from logEntries">
        <row (action)="entry.expanded = entry.expanded ? false : true"
          [statusIcon]="entry.expanded ? 'clipboard-list' : 'clipboard-check'"
          statusColor="color-blue-50"
          [attr.data-entity-type]="entry.entityType"
          [attr.data-primary-key]="entry.primaryKey ?? entry.entityId"
          [attr.data-primary-relation-entity-type]="entry.primaryRelationEntityType">
          <column [sortValue]="entry.timestamp">{{ entry.timestamp | customDate }}</column>
          <column>{{ !entry.metaDataType ? ('seach-log.modified-properties' | translate: { 'properties': getChangedProperties(entry) }) : ('log.meta-data.' + entityChangeLogMetaDataType.getKeys().get(entry.metaDataType)) | translate }}</column>
          <column>{{ entry.entityId.substring(0,8) }}</column>
          <column>{{ entry.user | user: 'initials' }}</column>
        </row>
        @if (entry.expanded) {
          <row-details class="indent">
            @if (entry.metaDataType) {
              <div>{{ 'log.meta-data.detailed.' + entityChangeLogMetaDataType.getKeys().get(entry.metaDataType) | translate: entry.metaData }}</div>
            }
            <log-changes [hideUnchanged]="true" [previousEntity]="entry.previousValue" [currentEntity]="entry.currentValue" />
          </row-details>
        }
      </ng-container>
    </list-view>
  }

  @if (!logEntries) {
    <skeletons [defaultSkeletons]="4" />
  }
</panel>
